export const TEST_ID = 'primaryButton';
